import Mixpanel from "../../config/mixpanel-config";
import PostHog from "../../config/posthog-config";
import TagManager from 'react-gtm-module';

export function setAnalyticsCommonEvent(mixpanelUserId : string, event : string, data : any) {
    Mixpanel.identify(mixpanelUserId);
    Mixpanel.track(event, data);

    PostHog.identify(mixpanelUserId);
    PostHog.capture(event, data);

    data.event = event
    const tagManagerArgs = { dataLayer: data}
    TagManager.dataLayer(tagManagerArgs)
}
